<div
  class="content-section"
  [style.max-width]="maxWidth"
  [style.padding]="padding"
  [style.background-color]="backgroundColor"
>
  <ng-content></ng-content>
</div>
